<template>
  <v-card class="elevation-1 rounded-card">
    <v-card-title class="headline">{{ cardTitle }}</v-card-title>
    <v-card-text>
      <px-negociacao-diff-dados-basicos
        v-if="negociacao.negociacao.campos.length"
        :resposta="resposta"
        :negociacao="negociacao"/>
      <v-divider v-if="negociacao.negociacao.campos.length && negociacao.produtos.length"/>
      <px-negociacao-diff-dados-produtos v-if="negociacao.produtos.length"
                                         :resposta="resposta"
                                         :negociacao="negociacao"
                                         :download-file-path="downloadFilePath"/>
      <v-row dense>
        <v-col cols="12">
          <span class="font-weight-bold">Mensagem</span>
          <div>
            <px-show-large-text :large-text="negociacao.message"/>
          </div>
        </v-col>
      </v-row>
      <v-row dense v-if="negociacao.arquivos.length">
        <v-col cols="12">
          <span class="font-weight-bold">Arquivos</span>
          <px-anexo-chip :files="negociacao.arquivos"
                         :download-base-path="downloadFilePath"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { TipoNegociacao } from 'px-business-components';
import NegociacaoDiffDadosBasicos from './NegociacaoDiffDadosBasicos.vue';
import NegociacaoDiffDadosProdutos from './NegociacaoDiffDadosProdutos.vue';

export default {
  props: {
    negociacao: Object,
    resposta: {
      type: Object,
      required: true,
    },
    isComprador: Boolean,
  },
  computed: {
    cardTitle() {
      if (this.negociacao.tipo === TipoNegociacao.keys.SOLICITACAO.key) {
        return 'Negociação solicitada';
      }
      return 'Resposta da negociação';
    },
    downloadFilePath() {
      if (this.isComprador) {
        return 'files/download-comprador';
      }
      return 'files/download-fornecedor';
    },
  },
  components: {
    pxNegociacaoDiffDadosBasicos: NegociacaoDiffDadosBasicos,
    pxNegociacaoDiffDadosProdutos: NegociacaoDiffDadosProdutos,
  },
};
</script>
